import { AxiosRequestConfig } from 'axios'
import toast from 'react-hot-toast';
import { FC, memo, useState } from 'react'
import { useForm } from 'react-hook-form'
import { ErrorResponse, SuccessResponse } from 'ts/types/ApiResponse'
import { Button } from 'components/ui'
import { http } from 'utils'
import { useTrader } from 'context/TraderTypeContext';
import GetUrls from 'ts/enums/Url'
import useModalStore from 'store/modal'
import shallow from 'zustand/shallow'
import ButtonOutline from 'components/ui/ButtonOutline'
import useDataTableStore from 'store/dataTable'
import useAuthStore from 'store/auth'
import FormFormatter from '../utils/formFormatter';

type FormProps = {
  altApiCall?: AxiosRequestConfig;
  url?: string;
  method?: AxiosRequestConfig['method'];
  children?: React.ReactNode;
};

const useDynamicForm = () => {
  const Url = GetUrls();
  const { traderId } = useTrader();
  const formatter = FormFormatter();

  const form = useForm();
  const user = useAuthStore((state) => state.user);
  const [onRequestClose, setIsSubmit] = useModalStore(
    (state) => [state.onRequestClose, state.setIsSubmit],
    shallow
  )

  const handleCloseModal = () => {
    onRequestClose();
  };
  
  const { handleSubmit, reset, setValue } = form
  const [isLoading, setIsLoading] = useState(false)
  const [success] = useState<SuccessResponse>()
  const [error] = useState<ErrorResponse>()
  const reload = useDataTableStore((state) => state.reload)

  const onSubmit = async (config: AxiosRequestConfig, altApiCall?: AxiosRequestConfig) => {
    setIsSubmit(true);
    setIsLoading(true);
    try {
      let thorProductId: string | undefined;
      if (altApiCall && altApiCall.method === "POST") {
        let formatData = formatter.modifyResJava(config.data, altApiCall.url, traderId, user);
        const altResp = await http.request({
          url: altApiCall.url,
          method: altApiCall.method,
          data: formatData
        });
        thorProductId = (altResp.data as { productId?: string }).productId;
        console.log("altResp PASSED:",altResp)
        console.log("THOR PRODUCT ID PASSED:",thorProductId)
      } else if (altApiCall && altApiCall.method === "PUT"){
        let formatData = formatter.modifyResJava(config.data, altApiCall.url, traderId, user);
        await http.request({
          url: altApiCall.url,
          method: "POST",
          data: formatData
        });
      }
  
      const mainData = config.url === Url.postProduct ? 
        formatter.modifyMainRes({ ...config.data, thorProductId }, config.method, config.url, traderId) : 
        config.url === Url.postUser ? 
        formatter.modifyUser(config.data, config.url, traderId) : 
        config.url === Url.postLayout ? 
        formatter.modifyProductLayout(config.data, traderId) : 
        config.data;
        
      const mainresp = await http.request({
        url: config.url,
        method: config.method,
        data: mainData
      });

      const responseData = mainresp.data as { productId?: string, layoutId?: number };

      // Handle Product Tax requests
      if(config.url === Url.postProduct){
        await http.request({
          url: Url.productTaxType,
          method: "PUT",
          data: {
              "productTaxId":config.data.productTaxId,
              "productId": responseData.productId,
              "taxTypeId": config.data.taxTypeId,
              "startDate": "2014-08-06T12:17:25.132Z",
              "endDate": "2288-05-21T12:17:25.456Z"
            }
        });

        // Handle productPriceLevel requests
        await http.request({
          url: Url.postProductPriceLevel,
          method: "PUT",
          data: {
            "productPriceLevelId": config.data.productPriceLevelId,
            "productId": config.data.productId ? config.data.productId : responseData.productId,
            "currencyId": 1,
            "price": config.data.price ? config.data.price : '0',
            "openPriceMax": config.data.openPriceMax !== '' ? config.data.openPriceMax : null ,
            "openPriceMin": config.data.openPriceMin !== '' ? config.data.openPriceMin : null ,
            "flDefault": 1,
          }
        });
      }

      // Handle Product Layout
      if (config.url === Url.postLayout) {
        let layoutIdData = config.data.layoutId ? config.data.layoutId : responseData.layoutId
        await http.request({
          url: Url.productLayout + layoutIdData,
          method: "POST",
          data: formatter.filterLayoutData(config.data.layoutData)
        });
      }

      toast.success('Successfully saved');
      if (config.method?.toUpperCase() === 'POST' || config.method?.toUpperCase() === 'PUT') {
        reset();
        onRequestClose();
      }
    } catch (e: any) {
      toast.error(e.message);
    }
    setIsLoading(false);
    setIsSubmit(false);
    reload();
  };

  const Form: FC<FormProps> = ({ children, url, method ,altApiCall }) => (
    <form
      onSubmit={ handleSubmit((data) => onSubmit({ url, data, method }, altApiCall )) }
      className="flex flex-col w-full"
    >
      {children}
      <div className='flex'>
        <Button
          isLoading={isLoading}
          className="w-40 mt-4 z-20 relative"
          // disabled={ !formState.isDirty }
        >
          Submit
        </Button>
        <ButtonOutline
          onClick={handleCloseModal}
        >
          Cancel
        </ButtonOutline>
      </div>
    </form>
  )

  setValue('programId', Number(user.programId));
  return { Form: memo(Form), isLoading, error, success, form }
}

export default useDynamicForm
